import * as React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { selectRosreestrData } from '../../selectors/rosreestrData';
import { RosreestrData } from './RosreestrData';
import { trackRosreestrDataShow } from './tracking';

export const RosreestrDataContainer = () => {
  const rosreestrData = useSelector(selectRosreestrData, shallowEqual);

  const handleDataShow = React.useCallback(() => {
    trackRosreestrDataShow();
  }, []);

  if (!rosreestrData) {
    return null;
  }

  return <RosreestrData {...rosreestrData} onDataShow={handleDataShow} />;
};
